'use client';

import { HelmetProvider as ReactHelmetProvider } from 'react-helmet-async';

type Props = {
  children: React.ReactNode;
};

export function HelmetProvider({ children }: Props) {
  return <ReactHelmetProvider>{children}</ReactHelmetProvider>;
}
